// extracted by mini-css-extract-plugin
module.exports = {"pagination":"List_pagination_NMVmd","paginationText":"List_paginationText_O5fyb","paginationButton":"List_paginationButton_3ubvU"};